import script from "./CardNotFound.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardNotFound.vue?vue&type=script&setup=true&lang=ts"

import "./CardNotFound.vue?vue&type=style&index=0&id=697e189d&lang=scss"

const __exports__ = script;

export default __exports__